@if ((apps$ | async) === null) {
  <div class="flex justify-center items-center w-full h-full">
    <mat-progress-spinner
      mode="indeterminate"
      [strokeWidth]="3"
      [diameter]="20"
    ></mat-progress-spinner>
  </div>
} @else {
  <!-- See styles overrides in styles.scss -->
  @if ((currentAppIsNotOwnedByUser$ | async) === false) {
    <rk-dropdown
      class="app-list-dropdown"
      [options]="appsListDropdown"
      [selectedOption]="selectedApp"
      [whiteBackground]="true"
      (selectionChange)="onDropdownSelectionChange($event)"
    >
    </rk-dropdown>
  }
}
